<template>
    <div>

        <vue-headful title="Employee Disciplinary Actions :: MeritEHS"/>

        <div class="container d-print-none">
            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/disciplinary-actions`">
                            <i class="fa fa-gavel"></i> Disciplinary Actions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/disciplinary-actions/view/${id}`">
                            <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                            <template v-else>{{ action.other_violation_name }}</template>
                            on {{ action.disc_action_date | moment("MM/DD/YYYY") }} by {{ action.employee_first_name }} {{ action.employee_last_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-file-pdf-o"></i> PDF</li>
                </ol>
            </h4>
        </div>

        <div class="container bg-white d-print-none py-4 mb-4">
            <div class="alert alert-info">
                <strong>How to Export as PDF:</strong>
                <ol>
                    <li>On your browser, there should be a "File" or "Options" tab with a "Print" option. You may also hold down the "Ctrl" key and press the "P" key.</li>
                    <li>This will bring up the print page options box. There should be an option called "Select Printer" or "Destination".</li>
                    <li>Select "Save as PDF" or "Adobe PDF".</li>
                    <li>Click "Save" or "Print". This will open your file explorer and let you save it to your computer as a PDF.</li>
                </ol>
            </div>
        </div>

        <div class="container bg-white py-4">
            <h3 style="text-align:center"> Employee Disciplinary Action Form</h3>
            <h4>Details</h4>
            <div class="row mb-4">
                <div class="col-xl-6 col-lg-12 mb-xl-0 mb-lg-2">
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Date:</div>
                        <div class="col-md-8">{{ action.disc_action_date | moment("MM/DD/YYYY") }}</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Supervisor:</div>
                        <div class="col-md-8"><user-name :user="supervisor" :plainText="true" /></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Employee:</div>
                        <div class="col-md-8">{{ action.employee_first_name }} {{ action.employee_last_name }}</div>
                    </div>
                    <div class="row mb-2" v-if="incident">
                        <div class="col-md-4 text-muted">Incident:</div>
                        <div class="col-md-8"><incident-name :incident="incident" /></div>
                    </div>

                </div>
                <div class="col-xl-6 col-lg-12">
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Warning Type:</div>
                        <div class="col-md-8">{{ action.warning_type }}</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Discharged:</div>
                        <div class="col-md-8">
                            <label class="text-danger" v-if="action.was_discharged == 1">Yes</label>
                            <label class="text-success" v-else>No</label>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Violation:</div>
                        <div class="col-md-8">
                            <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                            <template v-else>{{ action.other_violation_name }}</template>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Penalty:</div>
                        <div class="col-md-8">
                            <template v-if="action.disc_violation_id">{{ action.penalty_name }}</template>
                            <template v-else>{{ action.other_penalty_name }}</template>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4 text-muted">Bonus Disqualification:</div>
                        <div class="col-md-8">
                            <template v-if="action.disc_violation_id">{{ action.other_bonus_disqual_time }}</template>
                            <template v-else>{{ action.other_bonus_disqual_time }}</template>
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="mt-4">Violation Details</h4>
            <div class="mb-4" v-html="action.violation_detail"></div>

            <h4 class="mt-4">Employee Reason(s) for action</h4>
            <div class="mb-4" v-html="action.reason_detail"></div>
            <hr/>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    Supervisor: <strong><user-name :user="supervisor" /></strong><br/>
                    Date Signed: <strong>{{ action.supervisor_sig_date | moment("MM/DD/YYYY") }}</strong>
                    <template v-if="action.supervisor_sig_id">
                        <img v-bind:src="loadSignature(action.supervisor_sig)" class="img-fluid" :ref="`file-${action.supervisor_sig.file_id}`">
                    </template>
                </div>
            </div>
            <hr/>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    Employee: <strong>{{ action.employee_first_name }} {{ action.employee_last_name }}</strong><br/>
                    Date Signed: <strong>{{ action.employee_sig_date | moment("MM/DD/YYYY") }}</strong>
                    <template v-if="action.employee_sig_id">
                        <img v-bind:src="loadSignature(action.employee_sig)" class="img-fluid" :ref="`file-${action.employee_sig.file_id}`">
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                loading: true,
                id: this.$route.params.id,
                action: {},
                incident: null,
            }
        },

        computed: {
            supervisor() {
                return {
                    FirstName: this.action.supervisor_first_name,
                    LastName: this.action.supervisor_last_name,
                    deleted_at: this.action.supervisor_deleted_at,
                };
            },
        },

        methods: {
            getAction(){
                //Send it
                this.$http.get('employees/disciplinary-actions/view/'+this.id)
                    .then(res => {
                        //Set
                        this.action = res.data.action;
                        this.incident = res.data.incident;
                    })
                    .then(() => {
                        //Loading
                        this.loading = false;
                    })
            },

            loadSignature(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + file.file_id].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });

                //Need to return null so it fills the source
                return null;
            },
        },

        mounted(){
            this.getAction();
        }
    }
</script>
<style scoped>
    .break-protect {
        page-break-inside: avoid;
    }
    .body {
        margin: 25mm;
    }
    @page {
        margin-top: 1in;
        margin-bottom: 1in;
    }
</style>